export const appConfig = {
    env: process.env.REACT_APP_ENV,
    assetsUrl: 'https://assets.vitastudent.com/concierge',
    backend: process.env.REACT_APP_STUDENT_BOOKING_BACKEND_URL,
    myAccountUrl: {
        vs: process.env.REACT_APP_MY_ACCOUNT_URL,
        hos: process.env.REACT_APP_MY_ACCOUNT_URL_HOS,
    },
    getLicencePdfUrl: process.env.REACT_APP_GET_LICENCE_AGREEMENT_PDF_URL,
    getBookingTermsPdfUrl: process.env.REACT_APP_GET_BOOKING_TERMS_PDF_URL,
    brochureSiteUrl: {
        vs: process.env.REACT_APP_BROCHURE_SITE_URL,
        hos: process.env.REACT_APP_BROCHURE_SITE_URL_HOS,
    },
    queryRetryAmount: process.env.REACT_APP_QUERY_RETRY_AMOUNT,
    supabase: {
        url: process.env.REACT_APP_SUPABASE_URL,
        anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY,
        cookies: {
            accessTokenKey: process.env.REACT_APP_SUPABASE_ACCESS_TOKEN_KEY,
            refreshTokenKey: process.env.REACT_APP_SUPABASE_REFRESH_TOKEN_KEY,
            domain: process.env.REACT_APP_SUPABASE_COOKIE_DOMAIN,
            hosDomain: process.env.REACT_APP_SUPABASE_COOKIE_DOMAIN_HOS,
        },
        enabled: process.env.REACT_APP_SUPABASE_ENABLED === 'true',
    },
    enableOriaAltJourney: process.env.REACT_APP_ENABLE_ORIA_ALT_JOURNEY_ENABLED === 'true',
    roomsAvailabilityMinimumStayDuration: process.env.REACT_APP_MINIMUM_STAY_DURATION,
    roomsAvailabilityMinimumStayDurationDws: process.env.REACT_APP_MINIMUM_STAY_DURATION_DWS,
};
